<template>
  <md-card
    class="md-card-unspaced public-card rfider-shadow"
    v-if="collectionInfo"
  >
    <div v-if="collectionInfo.image || collectionInfo.secondaryImage">
      <div
        class="public-support-image"
        :style="{
          'background-image': collectionInfo.image
            ? `url(${mixinGetFilePath(
                collectionInfo.image,
                imageExtension === 'gif' ? 'O' : 'XL',
              )})`
            : 'none',
          cursor: collectionInfo.imageLink ? 'pointer' : '',
        }"
        v-on="
          collectionInfo.imageLink
            ? { click: () => openLink(collectionInfo.imageLink, 'imageLink') }
            : ''
        "
      >
        <div
          v-if="collectionInfo.secondaryImage"
          :style="{
            'background-image': collectionInfo.secondaryImage
              ? `url(${mixinGetFilePath(
                  collectionInfo.secondaryImage,
                  secondaryImageExtension === 'gif' ? 'O' : 'XL',
                )})`
              : 'none',
          }"
          class="public-support-secondary-image"
        ></div>
      </div>
    </div>

    <md-card-content class="public-card-content">
      <div class="public-card-name ql-editor" v-if="collectionInfo.title">
        {{ collectionInfo.title }}
      </div>
      <div v-if="collectionInfo.phone">
        <a :href="`tel:${collectionInfo.phone}`" target="_blank">
          <img :src="'/img/avatars/avatar-phone.png'" class="avatar-image" />
          {{ collectionInfo.phone }}
        </a>
      </div>
      <div v-if="collectionInfo.email">
        <a :href="`mailto:${collectionInfo.email}`" target="_blank">
          <img :src="'/img/avatars/avatar-email.png'" class="avatar-image" />
          {{ collectionInfo.email }}
        </a>
      </div>
      <div v-if="collectionInfo.message">
        <div
          v-if="collectionInfo.expanded"
          class="ql-editor"
          v-html="collectionInfo.message"
        ></div>
        <div v-else class="ql-editor">
          <public-expand
            :item="collectionInfo.message"
            refKey="support"
          ></public-expand>
        </div>
      </div>
      <div v-if="collectionInfo.allowOrgFilter">
        <swiper
          ref="organization"
          class="swiper"
          :options="OrganizationFilterswiperOption"
        >
          <swiper-slide
            v-for="(org, index) in organizationFilterData"
            :key="index"
            class="swiper-slide"
          >
            <div class="organization-filter__box">
              <div
                @click="filterBasedOnOrganization(org)"
                class="organization-filter__container"
              >
                <div>
                  <img
                    :src="mixinGetFilePath(org.orgImage)"
                    class="organization-filter__image"
                  />

                  <md-icon
                    v-if="filteredOrganizationList.includes(org)"
                    class="organization-filter__selected-image-icon"
                  >
                    done
                  </md-icon>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <div class="md-layout menu-bar md-alignment-center-space-between">
        <div
          class="md-layout-item md-xsmall-size-10 md-size-5"
          v-if="collectionInfo.allowSwitchMode"
        >
          <div
            class="gallery-view-outline"
            v-if="!listView"
            @click="listView = true"
          >
            <img class="gallery-view-img" src="/img/icons/List2.png" alt="" />
          </div>
          <div class="gallery-view-outline" v-else @click="listView = false">
            <img
              class="gallery-view-img"
              src="/img/icons/Portrait2.png"
              alt=""
            />
          </div>
        </div>
        <div
          class="md-layout-item search-and-filter-container"
          :class="
            collectionInfo.allowSwitchMode
              ? 'md-xsmall-size-80 md-size-95'
              : 'md-size-100'
          "
        >
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-size-90">
              <search-bar
                @search="updateSearchText($event)"
                customPlaceHolder="Search"
                :fullWidth="true"
                ref="searchBar"
              >
              </search-bar>
              <!-- <div class="container">
                <div id="search-box" tabindex="1">
                  <search-bar
                    @search="updateSearchText($event)"
                    customPlaceHolder="Search"
                    :fullWidth="true"
                    ref="searchBar"
                  >
                  </search-bar>
                </div>
              </div> -->
            </div>
            <div class="md-layout-item md-size-10">
              <md-menu md-size="auto" md-align-trigger>
                <md-button md-menu-trigger class="md-simple md-just-icon">
                  <md-icon>more_vert</md-icon>
                </md-button>
                <md-menu-content>
                  <md-menu-item @click="sortedByProduct = !sortedByProduct">
                    Sort by product
                  </md-menu-item>
                  <md-menu-item @click="sortedByProducer = !sortedByProducer">
                    Sort by producer
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
            </div>
          </div>
        </div>
      </div>
      <div v-if="filteredData && filteredData.length">
        <div v-if="listView" class="list-view-scroller">
          <div
            v-for="(item, index) in filteredData"
            :key="index"
            class="list-view-container md-layout md-alignment-center-space-between"
            @click="openLink(item.publicUrl)"
          >
            <div
              class="list-view-image-container md-layout-item md-size-10 md-xsmall-size-20"
            >
              <img
                class="list-view-image"
                v-if="item.orgImage"
                :src="
                  mixinGetFilePath(
                    item.orgImage,
                    isGifImage(item.orgImage) === 'gif' ? 'O' : 'XL',
                  )
                "
              />
            </div>
            <div class="md-layout-item md-size-85 md-xsmall-size-70">
              <div class="md-body-2 list-view-text">
                {{ item.name }}
              </div>
              <div class="md-body-1 list-view-subtext">
                {{ item.orgName }}
              </div>
            </div>
          </div>
        </div>
        <swiper
          v-else
          ref="gallerySwiper"
          class="swiper"
          :options="swiperOption"
          :lazy="true"
        >
          <swiper-slide
            v-for="(item, index) in filteredData"
            :key="index"
            class="swiper-slide"
          >
            <div class="slider__box" @click.prevent="openLink(item.publicUrl)">
              <div class="slider__container">
                <img
                  :src="
                    mixinGetFilePath(
                      item.image,
                      isGifImage(item.image) === 'gif' ? 'O' : 'XL',
                    )
                  "
                  class="swiper-lazy slider__image"
                />
              </div>
              <div
                class="md-layout md-alignment-center-left"
                style="padding: 5px"
              >
                <div class="md-layout-item md-size-15" v-if="item.orgImage">
                  <img
                    class="swiper-lazy"
                    :src="
                      mixinGetFilePath(
                        item.orgImage,
                        isGifImage(item.orgImage) === 'gif' ? 'O' : 'S',
                      )
                    "
                    alt=""
                  />
                </div>
                <div class="md-layout-item" style="padding-left: 12px">
                  <div class="extended-view-text">
                    {{ item.name }}
                  </div>
                  <div class="extended-view-subtext">
                    {{ item.orgName }}
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div v-else class="no-data">No products to show</div>
    </md-card-content>
  </md-card>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import SearchBar from '@/components/generic/searchBar.vue';
import PublicExpand from '@/components/public/publicExpand.vue';
export default {
  data() {
    return {
      showDialog: false,
      listView: this.collectionInfo.defaultGalleryTemplate === 'list',
      search: '',
      organizationFilterData: [],
      filteredOrganizationList: [],
      siteLoading: require('../../../public/img/spinner.gif'),
      width: window.innerWidth,
      swiperOption: {
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
        },
        lazyLoading: true,
        watchSlidesVisibility: true,
        slidesPerView: window.innerWidth > 600 ? 3 : 1.4,
        spaceBetween: 15,
        centeredSlides: window.innerWidth > 600 ? false : true,
        ...(this.collectionInfo.galleryTransitionDurationSeconds && {
          autoplay: {
            delay: this.collectionInfo.galleryTransitionDurationSeconds * 1000,
          },
          disableOnInteraction: false,
        }),
        loop: false,
      },
      OrganizationFilterswiperOption: {
        slidesPerView:
          window.innerWidth > 600 ? 4.6 : window.innerWidth > 320 ? 3.6 : 2.6,
        spaceBetween:
          window.innerWidth > 600 ? 20 : window.innerWidth > 320 ? 6 : 8,
        centeredSlides: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
        },
        lazyLoading: true,
        watchSlidesVisibility: true,
        loop: false,
      },
      filteredData: [],
      sortedByProduct: false,
      sortedByProducer: false,
    };
  },
  components: {
    SearchBar,
    swiper,
    swiperSlide,
    PublicExpand,
  },
  props: {
    collectionInfo: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.organizationFilterData = Array.from(
      new Set(this.collectionInfo.productItems.map((a) => a.orgId)),
    ).map((orgId) => {
      return this.collectionInfo.productItems.find((a) => a.orgId === orgId);
    });

    this.filteredData = this.collectionInfo
      ? this.collectionInfo.productItems
      : [];

    if (this.collectionInfo.defaultSort) {
      if (this.collectionInfo.defaultSort === 'productName') {
        this.sortedByProduct = true;
      } else if (this.collectionInfo.defaultSort === 'orgName') {
        this.sortedByProducer = true;
      }
    }
  },
  computed: {
    imageExtension() {
      try {
        return this.collectionInfo.image.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return null;
      }
    },
    secondaryImageExtension() {
      try {
        return this.collectionInfo.secondaryImage.match(
          /\.([0-9a-z]+)(?:[?#]|$)/i,
        )[1];
      } catch (err) {
        return null;
      }
    },
    swiper() {
      return this.$refs.gallerySwiper.swiper;
    },
  },
  watch: {
    search(newVal) {
      newVal = newVal.toLowerCase();

      if (this.filteredOrganizationList.length) {
        if (!newVal) this.organizationFilter();
        let localFilteredData = [];
        if (
          this.collectionInfo &&
          Array.isArray(this.collectionInfo.productItems)
        ) {
          this.filteredData.map((item) => {
            if (
              item.name.toLowerCase().includes(newVal) ||
              item.orgName.toLowerCase().includes(newVal)
            ) {
              localFilteredData.push(item);
            }
          });
          this.filteredData = localFilteredData;
        }
        return;
      }
      this.filteredData = [];
      if (
        this.collectionInfo &&
        Array.isArray(this.collectionInfo.productItems)
      ) {
        this.collectionInfo.productItems.map((item) => {
          if (
            item.name.toLowerCase().includes(newVal) ||
            item.orgName.toLowerCase().includes(newVal)
          ) {
            this.filteredData.push(item);
          }
        });
      }
    },
    sortedByProduct(value) {
      this.sortByProduct(value);
    },
    sortedByProducer(value) {
      this.sortByProducer(value);
    },
  },
  methods: {
    filterBasedOnOrganization(item) {
      this.$refs.searchBar.searchText = '';
      this.filteredOrganizationList.includes(item)
        ? this.filteredOrganizationList.splice(
            this.filteredOrganizationList.findIndex(
              (data) => data.orgId === item.orgId,
            ),
            1,
          )
        : this.filteredOrganizationList.push(item);

      if (!this.filteredOrganizationList.length)
        this.filteredData = this.collectionInfo.productItems;
      else {
        this.organizationFilter();
      }
    },
    organizationFilter() {
      this.filteredData = [];
      this.filteredOrganizationList.map((org) => {
        this.collectionInfo.productItems.map((item) => {
          if (org.orgId === item.orgId) {
            this.filteredData.push(item);
          }
        });
      });
    },
    openLink(link, type = null) {
      window.open(link + '?back=1', type === 'imageLink' ? '_blank' : '_self');
    },
    updateSearchText(search) {
      this.search = search;
    },
    sortByProduct(value) {
      this.filteredData.sort((a, b) => {
        return value ? (a.name > b.name ? 1 : -1) : a.name < b.name ? 1 : -1;
      });
    },
    sortByProducer(value) {
      this.filteredData.sort((a, b) => {
        return value
          ? a.orgName > b.orgName
            ? 1
            : -1
          : a.orgName < b.orgName
          ? 1
          : -1;
      });
    },
    isGifImage(image) {
      try {
        return image.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-collections-gallery.scss';
</style>
